import { breakpointsByName } from 'config/breakpoints';

export const isLarge = (width) => width >= breakpointsByName.large;
export const isSmall = (width) => width < breakpointsByName.medium;
export const isExtraLarge = (width) => width >= breakpointsByName.xlarge;
